import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Ах, какая у нас пора была!<br/>
        Круто шла вразлёт, как парабола, <br/>
        Ну а я наверху, как погонщица.<br/>
        Кто же знал, что всё так закончится…
      </p>
      

      <p class="poem-block mb-3">
        К тихой пристани я пристала<br/>
        И давно сошла с пьедестала.<br/>
        Вот под мерные звуки анданте<br/>
        Вижу я, приближается Данте:<br/>
        Знать, дорога открыта в ад,<br/>
        А не в райский запретный сад.
      </p>
      

      <p class="poem-block mb-3">
        Что ж! Пойдём, куда путь ведёт:<br/>
        Надо просто идти вперёд, <br/>
        Принимая, что путь даёт.<br/>
        Надо просто вперёд идти<br/>
        До конца своего пути.
      </p>
      
    </div>
    `
  )
}

const itemDate = {
  rus: 'Ноябрь 2022'
}

const itemName = {
  rus: 'Ах, какая у нас пора была'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;